module.exports = __webpack_public_path__ + "img/bg_6.ab402957.png";